import React from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { PRIMARY_WHATSAPP, PRIMARY_CALL } from "../lib/i18n";

export const FloatingCTA = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin/research")) return null;
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3" data-testid="floating-cta">
      <a
        href={`https://wa.me/${PRIMARY_WHATSAPP}?text=${encodeURIComponent("Hello Ashish Point, I need help with a service.")}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="w-14 h-14 rounded-full bg-green-600 hover:bg-green-700 text-white flex items-center justify-center shadow-lg transition-colors focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
        data-testid="floating-whatsapp-btn"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a
        href={`tel:${PRIMARY_CALL}`}
        aria-label="Call Ashish Point"
        className="w-14 h-14 rounded-full bg-teal-700 hover:bg-teal-800 text-white flex items-center justify-center shadow-lg transition-colors focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
        data-testid="floating-call-btn"
      >
        <Phone className="w-6 h-6" />
      </a>
    </div>
  );
};

export default FloatingCTA;
